import React, { useState, useContext, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import { message, Modal } from 'antd';
import MemberPackage from './MemberPackage';
import { useNavigate } from 'react-router-dom';
import eventBus from '@utils/eventBus';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './payModal.module.scss'
import Utils from '@utils/utils';
import { AppContext } from '@utils/AppContext';
import Iconfont from '@utils/Iconfont';




const PayModal = forwardRef((props, ref) => {
    const navigate = useNavigate()
    const { rechargeModel, setRechargeModel, globalOrgInfo } = useContext(AppContext);
    const closeCallbackRef = useRef()
    const { serviceType, serviceTypeForFree } = props

    useImperativeHandle(ref, () => ({
        openrechargeClick,
    }));

    const openrechargeClick = (callback) => {
        closeCallbackRef.current = callback
        setRechargeModel(true)
    }

    useEffect(() => {
        if (!rechargeModel) {
            if (closeCallbackRef.current && typeof closeCallbackRef.current == 'function') {
                closeCallbackRef.current()
                closeCallbackRef.current = null
            }
        }
    }, [rechargeModel])

    const openModalToPay = (item) => {
        if (item.level != 'free') {
            // 需要登录
            const status = Utils.checkLoginStatus(() => openModalToPay(item))
            if (!status) return

            eventBus.emit('pc_prepay', item, false, 0, () => {
                eventBus.emit('updateUserInfo')
                eventBus.emit('getUserOrgInfo')
            }, () => setRechargeModel(false))
        } else {
            setRechargeModel(false)
            message.info('欢迎免费试用')
        }
    }

    const redemptioncodePage = () => {
        window.open("/home/product/redemptioncodePage")
    }

    return (
        <PSAIModal
            open={rechargeModel}
            footer={null}
            closable={false}
            maxWidth={1152}
            onCancel={() => setRechargeModel(false)}
        >
            <div className={styles.payModalWrap}>

                <p className={styles.exchangeBtn}
                    onClick={() => {
                        const status = Utils.checkLoginStatus(() => redemptioncodePage())
                        if (!status) return
                        redemptioncodePage()
                    }}><Iconfont className={styles.Icon} type="icon-redemptioncodeOutlined" /> 会员兑换</p>
                <div className="_beauty_scrollbar" style={{ paddingRight: '4px' }}>
                    {
                        globalOrgInfo?.isPersonal ? <p className={styles.bigTitle}>超值会员方案，团队协作选企业版更优惠</p>
                            : <p className={styles.bigTitle}>企业套餐单张低至 <span>¥0.16</span> 更有一站式交付服务</p>
                    }
                    {
                        serviceType && (
                            serviceTypeForFree ?
                                <p className={styles.payModalWrap_P}>
                                    <span>普通会员可享2张免费作图机会</span>
                                    <span>升级Pro Max或Ultra会员解锁更多额度</span>
                                </p> :
                                <p className={styles.payModalWrap_P}>升级Max/Ultra会员，即刻享受专属服务助手</p>
                        )
                    }
                    <MemberPackage />
                </div>
            </div>
        </PSAIModal>
    )
})

export default PayModal